
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#gst-tenants-aadvantagehotels-app-modules-hotel-assets-svg-amenities-concierge_svg-a)","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M13.5 11a2.5 2.5 0 01-3 0"}}),_c('path',{attrs:{"d":"M14 8.25a.25.25 0 110 .5.25.25 0 010-.5zm-4 0a.25.25 0 110 .5.25.25 0 010-.5z","fill":"#50657c"}}),_c('path',{attrs:{"d":"M12 14.5a6 6 0 006-6V3.131a1.984 1.984 0 00-1.2-1.837A12.413 12.413 0 0012 .5a12.413 12.413 0 00-4.795.794A1.984 1.984 0 006 3.131V8.5a6 6 0 006 6z"}}),_c('path',{attrs:{"d":"M18 7s-1.5-1.5-6-1.5S6 7 6 7m12-2s-1.5-1.5-6-1.5S6 5 6 5m6 9.5v9m11 0v-3.106a1.98 1.98 0 00-.77-1.58A14.775 14.775 0 0015 16.178m-6 0a14.775 14.775 0 00-7.23 2.636 1.98 1.98 0 00-.77 1.58V23.5"}}),_c('path',{attrs:{"d":"M9 13.7v2.8a6.339 6.339 0 003 1 6.338 6.338 0 003-1v-2.8"}}),_c('path',{attrs:{"d":"M14 20.25a.25.25 0 01.231.154.25.25 0 01-.054.273.25.25 0 01-.273.054.25.25 0 01-.154-.231.25.25 0 01.25-.25zm0 2.5a.25.25 0 01.231.154.25.25 0 01-.054.273.25.25 0 01-.273.054.25.25 0 01-.154-.231.25.25 0 01.25-.25z","fill":"#50657c"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"gst-tenants-aadvantagehotels-app-modules-hotel-assets-svg-amenities-concierge_svg-a"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    